import React, { useState, useEffect, useRef } from 'react'
import RichText from 'src/utils/RichText'
import LineTo from 'utils/LineTo';
import Bubble from './Bubble'
import Popup from './Popup'
import GetSettings from 'utils/GetSettings'
import InView from 'utils/InView'

const BespokeDiagram = ({ blok }) => {

    // Store the popup content
    const settings = GetSettings()
    const popupContentAll = {
        'N': {
            title: settings.first_bubble_popup_title, position: settings.first_bubble_popup_position, content: settings.first_bubble_popup_content
        },
        'M': {
            title: settings.second_bubble_popup_title, position: settings.second_bubble_popup_position, content: settings.second_bubble_popup_content
        },
        'J': {
            title: settings.third_bubble_popup_title, position: settings.third_bubble_popup_position, content: settings.third_bubble_popup_content
        }
    }

    // Control of the popup content
    const [popupContent, setPopupContent] = useState({title: '', position: '', content: ''})

    // Opens/closes the popup
    const [open, setOpen] = useState(false)
    function handleSetOpen(name) {
        setOpen(!open)
        // Swap the content only when opening
        if (open === false) {
            setPopupContent(popupContentAll[name])
        }
    }

    // Detect if the component is in view
    const ref = useRef();
    const isVisible = InView(ref, true);

    // Regenerate the triangle on resize and on load
    let [lines, setLines] = useState('')
    useEffect(() => {
        if (typeof window !== "undefined") {
            const handleResize = () => setLines(
                <>
                    <LineTo from="N" to="M" borderColor={'#091DF3'} borderWidth={'2px'} within={'triangle'} className={`delay-[1750ms] duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}/>
                    <LineTo from="M" to="J" borderColor={'#091DF3'} borderWidth={'2px'} within={'triangle'} className={`delay-[2000ms] duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}/>
                    <LineTo from="J" to="N" borderColor={'#091DF3'} borderWidth={'2px'} within={'triangle'} className={`delay-[2250ms] duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`}/>
                </>
            );
            window.addEventListener("resize", handleResize);
            handleResize()   
            return () => window.removeEventListener("resize", handleResize);
        }
    }, [isVisible]);

    return (
        <div className="my-16 lg:my-24">
            <div className="max-w-7xl px-6 lg:px-12 mx-auto">
                <div className="flex xl:flex-row flex-col items-start justify-center xl:gap-24 gap-12">
                <div className="xl:w-6/12 w-full prose md:text-xl text-lg">
                    <RichText>{blok.content}</RichText>
                </div>
                <div className="xl:w-6/12 w-full relative md:h-[700px] h-[400px] max-w-xl xl:max-w-none" ref={ref}>
                    <Bubble name="N" position="top" handleSetOpen={handleSetOpen} isVisible={isVisible}/> 
                    <Bubble name="M" position="bottom" handleSetOpen={handleSetOpen} isVisible={isVisible}/>
                    <Bubble name="J" position="left" handleSetOpen={handleSetOpen} isVisible={isVisible}/>
                    <div className="triangle">
                        {lines}
                    </div>
                    <Popup {...popupContent} open={open} handleSetOpen={handleSetOpen}/>
                </div>
                </div>
            </div>
        </div>
    )
}

export default BespokeDiagram